import React, { useEffect } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import useMonthSelectbox from '../../hooks/selectbox/useMonthSelectbox';

const months = (year, func) => {
  const nowY = Number(moment(new Date()).format('YYYY'));
  const nowM = Number(moment(new Date()).format('MM'));
  let cnt = 12;
  let result = [];
  
  if (year === nowY) {
    cnt = nowM;
  }
  
  for (let i = 1; i <= cnt; i++) {
    result.push({
      label: `${i}월`,
      data: i > 9 ? String(i) : `0${i}`
    });
  }
  return result;
}

function MonthSelectBox() {
  const [open, value, onOpen, onClick, onReset] = useMonthSelectbox();
  // const year = useSelector(state => state.common.yearValue)
  useEffect(() => {
    return () => onReset();
  }, []);

  // const month = months(year);
  const month = months();

  // useEffect(() => {
  //   onReset();
  // }, [year])
  
  return (
    <div className={
      clsx("new-select selct2", open && 'opened')
    }>
      <div
        className="selected_txt"
        onClick={onOpen}
      >
        {value.label}
      </div>
      <div className="select_option">
        <ul>
          {
            month.map((item) => (
              <li key={item.data}>
                <button
                  type="button"
                  value={item.label}
                  onClick={() => onClick(item)}
                  className={clsx(value.data === item.data && "selected")}
                >{item.label}</button>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}

export default MonthSelectBox;